import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@pma/components/common/tooltip"
import useTranslator from "@pma/hooks/use-translator"

interface RequiredFieldLabelProps {
  tooltipText?: string
}

export function RequiredFieldLabel({ tooltipText }: RequiredFieldLabelProps) {
  const { translate } = useTranslator()
  const message = tooltipText || translate("This field is required")

  return (
    <span className='inline-flex items-center gap-1'>
      <span className='text-red-500'>*</span>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className='inline h-3.5 w-3.5 cursor-help text-gray-400 hover:text-gray-600' />
        </TooltipTrigger>
        <TooltipContent>
          <p className='text-xs'>{message}</p>
        </TooltipContent>
      </Tooltip>
    </span>
  )
}
